const QR_LABELS = {
  BLANK: "Blank / Unassigned",
  PRODUCT_ASSIGNED: "Product Assigned",
  PACKAGE_INFO_ADDED: "Package Info Added",
  WAITING_FOR_PICKUP: "Waiting for Pickup",
  PICKED_UP_BY_RIDER: "Picked Up by Rider",
  RECEIVED_AT_WAREHOUSE: "Received at Warehouse",
  SHIPPED_OUT: "Shipped Out",
  OUT_FOR_LAST_MILE: "Out for Delivery",
  DELIVERED: "Delivered",
  CANCELLED: "Cancelled / Void",
};

const QR_COLORS = {
  BLANK: "bg-slate-500/10 text-slate-700 dark:text-slate-300 border-slate-500/30",
  PRODUCT_ASSIGNED: "bg-blue-500/10 text-blue-400 border-blue-500/30",
  PACKAGE_INFO_ADDED: "bg-purple-500/10 text-purple-400 border-purple-500/30",
  WAITING_FOR_PICKUP: "bg-yellow-500/10 text-yellow-400 border-yellow-500/30",
  PICKED_UP_BY_RIDER: "bg-blue-500/10 text-blue-400 border-blue-500/30",
  RECEIVED_AT_WAREHOUSE: "bg-indigo-500/10 text-indigo-400 border-indigo-500/30",
  SHIPPED_OUT: "bg-orange-500/10 text-orange-400 border-orange-500/30",
  OUT_FOR_LAST_MILE: "bg-teal-500/10 text-teal-400 border-teal-500/30",
  DELIVERED: "bg-green-500/10 text-green-400 border-green-500/30",
  CANCELLED: "bg-red-500/10 text-red-400 border-red-500/30",
};

export const QR_STATUS_LABELS = QR_LABELS;

export function QRStatusBadge({ status }) {
  const cls = QR_COLORS[status] || "bg-slate-200 dark:bg-slate-800 text-slate-700 dark:text-slate-300 border-slate-300 dark:border-slate-700";
  return (
    <span
      data-testid={`qr-status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider border ${cls}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {QR_LABELS[status] || status}
    </span>
  );
}
